var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-create-doc",
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.114,
    height: 127.468,
    viewBox: "0 0 118.114 127.468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M18.738,108.614H63.031v10.738H17.4A9.416,9.416,0,0,1,8,109.935V11.447a9.416,9.416,0,0,1,9.4-9.416H81.542a10.655,10.655,0,0,1,7.6,3.162l22.846,22.964a10.71,10.71,0,0,1,3.134,7.61v31H104.388v-31L81.533,12.767h-62.8Zm44.3,10.728,6.193.016-6.2-10.75Zm41.349-52.58,10.748,6.2-.016-6.193Zm21.732,35.752A26.845,26.845,0,1,1,99.27,75.532,26.914,26.914,0,0,1,126.114,102.515Zm-8.053-5.4H104.639V83.628H93.9V97.12H80.479v10.793H93.9V121.4h10.738V107.912h13.422Z",
    transform: "translate(-8 -2.031)",
    fill: "#0071b9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/upload_file_icon.de898d6c.svg";
export { ForwardRef as ReactComponent };